import {
  Box,
  Flex,
  Text,
  UnorderedList,
  ListItem,
  Center,
} from "@chakra-ui/react";
import React from "react";
import GradientTextWithStroke from "./index";

const Terms = () => {
  return (
    <Box
      backgroundColor="#09040D"
      minH="100vh"
      pb="40px"
      position="relative"
      overflow="hidden"
      py={{ base: 16, md: 22 }}
    >
      {/* Ambient Background Glows - Extended to cover longer page */}
      <Box position="absolute" top="2%" right="-15%" width={{ base: "300px", md: "700px" }} height={{ base: "300px", md: "700px" }} bg="radial-gradient(circle, rgba(139, 92, 246, 0.4) 0%, transparent 70%)" filter="blur(100px)" zIndex={0} pointerEvents="none" />
      <Box position="absolute" top="8%" left="-15%" width={{ base: "300px", md: "700px" }} height={{ base: "300px", md: "700px" }} bg="radial-gradient(circle, rgba(139, 92, 246, 0.3) 0%, transparent 70%)" filter="blur(110px)" zIndex={0} pointerEvents="none" />
      <Box position="absolute" top="15%" right="-15%" width={{ base: "350px", md: "800px" }} height={{ base: "350px", md: "800px" }} bg="radial-gradient(circle, rgba(139, 92, 246, 0.35) 0%, transparent 70%)" filter="blur(100px)" zIndex={0} pointerEvents="none" />
      <Box position="absolute" top="22%" left="-15%" width={{ base: "300px", md: "700px" }} height={{ base: "300px", md: "700px" }} bg="radial-gradient(circle, rgba(139, 92, 246, 0.3) 0%, transparent 70%)" filter="blur(110px)" zIndex={0} pointerEvents="none" />
      <Box position="absolute" top="30%" right="-15%" width={{ base: "300px", md: "700px" }} height={{ base: "300px", md: "700px" }} bg="radial-gradient(circle, rgba(139, 92, 246, 0.4) 0%, transparent 70%)" filter="blur(100px)" zIndex={0} pointerEvents="none" />
      <Box position="absolute" top="38%" left="-15%" width={{ base: "300px", md: "700px" }} height={{ base: "300px", md: "700px" }} bg="radial-gradient(circle, rgba(139, 92, 246, 0.3) 0%, transparent 70%)" filter="blur(110px)" zIndex={0} pointerEvents="none" />
      <Box position="absolute" top="45%" right="-15%" width={{ base: "350px", md: "800px" }} height={{ base: "350px", md: "800px" }} bg="radial-gradient(circle, rgba(139, 92, 246, 0.35) 0%, transparent 70%)" filter="blur(100px)" zIndex={0} pointerEvents="none" />
      <Box position="absolute" top="53%" left="-15%" width={{ base: "300px", md: "700px" }} height={{ base: "300px", md: "700px" }} bg="radial-gradient(circle, rgba(139, 92, 246, 0.3) 0%, transparent 70%)" filter="blur(110px)" zIndex={0} pointerEvents="none" />
      <Box position="absolute" top="60%" right="-15%" width={{ base: "300px", md: "700px" }} height={{ base: "300px", md: "700px" }} bg="radial-gradient(circle, rgba(139, 92, 246, 0.4) 0%, transparent 70%)" filter="blur(100px)" zIndex={0} pointerEvents="none" />
      <Box position="absolute" top="68%" left="-15%" width={{ base: "300px", md: "700px" }} height={{ base: "300px", md: "700px" }} bg="radial-gradient(circle, rgba(139, 92, 246, 0.3) 0%, transparent 70%)" filter="blur(110px)" zIndex={0} pointerEvents="none" />
      <Box position="absolute" top="75%" right="-15%" width={{ base: "350px", md: "800px" }} height={{ base: "350px", md: "800px" }} bg="radial-gradient(circle, rgba(139, 92, 246, 0.35) 0%, transparent 70%)" filter="blur(100px)" zIndex={0} pointerEvents="none" />
      <Box position="absolute" top="83%" left="-15%" width={{ base: "300px", md: "700px" }} height={{ base: "300px", md: "700px" }} bg="radial-gradient(circle, rgba(139, 92, 246, 0.3) 0%, transparent 70%)" filter="blur(110px)" zIndex={0} pointerEvents="none" />
      <Box position="absolute" top="90%" right="-15%" width={{ base: "300px", md: "700px" }} height={{ base: "300px", md: "700px" }} bg="radial-gradient(circle, rgba(139, 92, 246, 0.4) 0%, transparent 70%)" filter="blur(100px)" zIndex={0} pointerEvents="none" />
      <Box position="absolute" top="97%" left="-15%" width={{ base: "300px", md: "700px" }} height={{ base: "300px", md: "700px" }} bg="radial-gradient(circle, rgba(139, 92, 246, 0.3) 0%, transparent 70%)" filter="blur(110px)" zIndex={0} pointerEvents="none" />

      <Box
        w="100%"
        px={{ base: 4, md: 20 }}
        pb={{ base: 4, md: 6 }}
        zIndex={1}
      >
        <Flex direction="column" justify="center" align="center" h="100%">
          <Box
            textAlign={{ base: "center", md: "center" }}
            w="100%"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Text
              fontSize={{ base: "42px", sm: "60px", md: "100px" }}
              fontWeight="bold"
              bgGradient="linear(to-r, #fff , #BDA8FB)"
              bgClip="text"
              lineHeight="1"
              py={14}
            >
              Terms & Conditions
            </Text>
            <Text
              fontSize={{ base: "12px", md: "16px" }}
              fontWeight="medium"
              color="#FFFFFF"
              textAlign="center"
              maxW="900px"
              mt={4}
              textTransform="uppercase"
              letterSpacing="1px"
              lineHeight="1.6"
            >
              BEFORE REGISTERING WITH US, YOU SHOULD CAREFULLY READ THE TERMS PROVIDED ON THE WEBSITE WHICH ARE APPLICABLE TO ALL SERVICES ON THE WEBSITE AND GAME RULES APPLICABLE.
            </Text>
          </Box>
        </Flex>
      </Box>

      {/* Main Content */}
      <Flex width="100%" justifyContent="center" alignItems="center" mt={6} zIndex={1}>
        <Flex
          width={{ base: "90%", md: "85%" }}
          justifyContent="center"
          alignItems="center"
          flexDir={"column"}
          gap={10}
        >
          {/* Introduction - Center Aligned per image */}
          <Box w="100%" textAlign="center" display="flex" flexDirection="column" alignItems="center" gap={6}>
            <Text fontSize={{ base: "14px", md: "17px" }} color="#EEDCFF" maxW="1100px" lineHeight="1.6">
              These Terms and Conditions (“Terms”) govern your use of the Winnsta website, its connected mobile application (“Platform”) and related online free to play gaming services (“Services”) operated by M/s Purple Fox Leisure Private Limited (referred to as “Winnsta”, “Company”, “We”, “Us” or “Our”).
            </Text>
            <Text fontSize={{ base: "14px", md: "17px" }} color="#EEDCFF" maxW="1100px" lineHeight="1.6">
              By accessing or using the Platform, you (“User” “You”, “your” or “their”) agree to be bound by these Terms, the Privacy Policy and Legality (collectively, the “Platform Policies”) which forms a binding legal agreement between You and the Company, on the basis of which You may visit, access, or use the Platform, mobile applications, and Services. We reserve the right to periodically review, update, or otherwise modify any part of the Platform Policies at Our sole and absolute discretion, and accordingly, You are advised to keep Yourself updated on the latest versions of the Platform Policies. We will provide You with notice of any material modification to the Platform Policies, and Your continued access and use of the Services after such notification shall constitute consent to the modified Platform Policies.
            </Text>
            <Text fontSize={{ base: "14px", md: "17px" }} color="#EEDCFF" maxW="1100px" lineHeight="1.6">
              The User should read, understand and agree to the Terms which includes those terms and conditions expressly set out below and those incorporated by reference, which You can access by clicking on the relevant link. However, prior to initiating the process of opening an account on the Platform, the User assumes full responsibility to ascertain that they are not situated in a jurisdiction within, or outside India where free-to-play online social games are prohibited or deemed unlawful, and the User is not in breach of any legislation or regulation in force in a given jurisdiction.
            </Text>
          </Box>

          {/* DEFINITIONS per image */}
          <Box w="100%">
            <Text fontSize={{ base: "22px", md: "28px" }} fontWeight="bold" color="white" mb={6} textTransform="uppercase" letterSpacing="1px">
              DEFINITIONS
            </Text>

            <UnorderedList color="#EEDCFF" spacing={2} fontSize={{ base: "14px", md: "17px" }} pl={6} >
              <ListItem>  “Account” means the User account created on the Platform and maintained with the Company, which enables Users to play Games on the Platform.</ListItem>

              <ListItem> “Applicable Law(s)” means all applicable statutes, enactments, laws, ordinances, treaties, conventions, protocols, bye-laws, rules, regulations, guidelines, notifications, notices, and/ or judgments, decrees, injunctions, writs or orders, instructions, decisions of any court or and awards or other requirements or official directives of any governmental authority, within the territory of India as may be applicable on the User.</ListItem>

              <ListItem>  “Game(s)” means the online free-to-play games offered on the Platform, including its various formats and variations and quick/ practice games.</ListItem>

              <ListItem>“Restricted Territories” means any state in India where online gaming is prohibited under Applicable Laws or permitted only via appropriate license/ registration.</ListItem>

              <ListItem> “Service(s)” shall mean the offering of the Games on the Platform by the Company.</ListItem>
            </UnorderedList>

          </Box>

          {/* SERVICES per image */}
          <Box w="100%">
            <Text
              fontSize={{ base: "22px", md: "28px" }}
              fontWeight="bold"
              color="white"
              mb={6}
              textTransform="uppercase"
              letterSpacing="1px"
            >
              SERVICES
            </Text>

            <UnorderedList
              color="#EEDCFF"
              spacing={2}
              fontSize={{ base: "14px", md: "17px" }}
              pl={6}
            >
              <ListItem>
                The Services offered on the Platform are purely in respect of free-to-play versions of Games and its related activities. It is hereby clarified that no participation fees, entry fees, deposits, or monetary stakes are accepted, collected, or processed from Users by the Platform under any circumstances in order to participate in the Games.
              </ListItem>

              <ListItem>
                The Platform does provide for in-app purchases for strictly cosmetic value addition, i.e., that does not amount to any real-world value and does not improve the user’s chances of winning. These include and are not limited to decorated decks, themes, skins [*]
              </ListItem>

              <ListItem>
                The Users are strictly prohibited from transferring or attempting to transfer any funds, or equivalent items of monetary value within or outside the Platform in connection with gameplay or participation.
              </ListItem>

              <ListItem>
                All forms of monetary collection, wagering, betting, or staking of value between Users are expressly disallowed on the Platform.
              </ListItem>

              <ListItem>
                The Company does not facilitate, process, or permit any wallet top-ups, cash deposits, or financial transactions in its Services that could constitute an ‘online money game’ under the Promotion and Regulation of Online Gaming Act, 2025 (“PROGA”) or any applicable state law within the jurisdiction of the Republic of India.
              </ListItem>

              <ListItem>
                Any attempt by a User to circumvent this restriction shall result in immediate suspension or termination of the Account (defined hereinbelow) and forfeiture of any Reward Points, without prejudice to the Company’s rights to take further legal action.
              </ListItem>
            </UnorderedList>
          </Box>
          {/* TOURNAMENTS */}
          <Box w="100%">
            <Text
              fontSize={{ base: "22px", md: "28px" }}
              fontWeight="bold"
              color="white"
              mb={6}
              textTransform="uppercase"
              letterSpacing="1px"
            >
              TOURNAMENTS
            </Text>

            <UnorderedList
              color="#EEDCFF"
              spacing={2}
              fontSize={{ base: "14px", md: "17px" }}
              pl={6}
            >
              <ListItem>
                The Company shall, through Services and by organizing specific free-to-play tournaments (“Tournament”), in order to play the Games. These Tournaments shall have pre-defined prizes for a specified number of Users that win the Tournament.
              </ListItem>

              <ListItem>
                All rewards, prizes, or related honorariums shall be in the form of pre-defined prizes which the Users are aware of and awarded to Users based on their performance and final ranking Tournament. For the avoidance of doubt, neither the rewards, prizes, or related honorariums are funded through any form of User contribution, entry fee, deposit or stake.
              </ListItem>

              <ListItem>
                A User’s final position at the end of a Tournament determines the rewards, prizes, or related honorariums that the Platform shall offer. It is emphasized that the rewards, prizes, or related honorariums cannot be redeemed for real-money, outside of the Platform.
              </ListItem>

              <ListItem>
                The Company reserves the right to withhold or cancel any rewards, prizes, or related honorariums if it suspects any fraudulent activity, unfair gameplay, or non-compliance with Applicable Laws or Platform Policies.
              </ListItem>
            </UnorderedList>
          </Box>
          {/* RIGHT TO ACCESS THE SERVICES per image */}
          <Box w="100%">
            <Text
              fontSize={{ base: "22px", md: "28px" }}
              fontWeight="bold"
              color="white"
              mb={6}
              textTransform="uppercase"
              letterSpacing="1px"
            >
              RIGHT TO ACCESS THE SERVICES
            </Text>

            <UnorderedList
              color="#EEDCFF"
              spacing={2}
              fontSize={{ base: "14px", md: "17px" }}
              pl={6}
            >
              <ListItem>
                Our Platform and Services are not available to anybody under the age of 18 (eighteen) on the day of User Registration through the registration process as defined here in below. We reserve the right to request proof of age at any stage to verify that the declaration of age provided by You at the time of registration is genuine and We may prohibit usage of the Platform or the Services to a person if proof of age is not provided upon request or if the Company suspects that a person using the service is under-age.
              </ListItem>

              <ListItem>
                The Services are not intended for Users connecting to the Platform from Restricted Territories that state it is illegal to do so as is evidenced in our Legality document. If any person becomes a User of the Platform by giving false information, the liability will be solely on the User and the Company reserves the right to terminate the User's Account without any notice. If the Company finds a User playing on the Platform, being under the age of 18 (eighteen), such Users account(s) will be terminated with immediate effect. Such User shall keep the Company, its affiliates, officers, representatives and agents fully indemnified from such misrepresentation. You accept that the Company will not be liable to take any responsibility for the breach by the User of Applicable Laws.
              </ListItem>

              <ListItem>
                We reserve the right to terminate Your access and use of the Services when We become aware of or are of the opinion, at Our sole discretion, that Your use and access of the Service(s) is in violation of the Platform Policies.
              </ListItem>

              <ListItem>
                The Applicable Laws in certain states may prohibit a User from using the Services offered on our Platform. You agree that You are not from the Restricted Territories and You shall refrain from making any false disclosures, declarations and/or representations to Us to circumvent the Applicable Laws and/or regulations of the of the Restricted Territories to participate in any Games. There may be applicable penalties imposed on such a User by the respective State Governments or the Central Government as the case may be. The Company does not accept User requests from people who are residing in these jurisdictions and if a User residing in such jurisdiction becomes a member of the Platform by giving false information, the liability will be solely on the User and the Company reserves the right to terminate the User's Account without any notice.
              </ListItem>

              <ListItem>
                If it is found that a User is engaging in Games on our Platform via an IP address of any Restricted Territory(ies), such Users Account(s) will be terminated with immediate effect. Such User shall keep the Company, its affiliates, officers, representatives and agents fully indemnified from such misrepresentation. You accept that the Company will not be liable to take any responsibility for the breach of the User of Applicable Laws. Users from all jurisdictions have to always ensure that they are following the Applicable Laws. Our decision in this regard will be final, and no consideration whatsoever will be extended to the User.
              </ListItem>
            </UnorderedList>
          </Box>

          {/* USAGE OF THE SERVICES per image */}
          <Box w="100%">
            <Text
              fontSize={{ base: "22px", md: "28px" }}
              fontWeight="bold"
              color="white"
              mb={6}
              textTransform="uppercase"
              letterSpacing="1px"
            >
              USAGE OF THE SERVICES
            </Text>

            <UnorderedList
              color="#EEDCFF"
              spacing={2}
              fontSize={{ base: "14px", md: "17px" }}
              pl={6}
            >
              <ListItem>
                Winnsta reserves the right, but is under no obligation, to monitor, review, pre-screen, edit, remove, or disable access to any User content at its sole discretion allows You to play the free to play game of Games through our Platform.
              </ListItem>

              <ListItem>
                When You access the Services and/or create an Account on the Platform, We may collect, use, share with third parties, store, or otherwise process Your information, which may include Your personal information and sensitive personal information, to ensure that the Services may be accessed and used by You efficiently. The collection, use, sharing of such information is governed by the Privacy Policy which forms an integral part of the Platform Policies. You may access the Privacy Policy here.
              </ListItem>

              <ListItem>
                You are required to verify Your mobile number at the time of registration on the Platform. All Your information is kept confidential and processed as per Our Privacy Policy.
              </ListItem>

              <ListItem>
                We reserve the right, at our sole discretion, to modify, update, or amend any aspect of the Services at any time by providing You with a notice of the same. These changes may be made to ensure compliance with regulatory requirements, enhance user experience, and support the efficient operation of the platform.
              </ListItem>

              <ListItem>
                When You register with Us, You agree to receive promotional and service messages from Us, and our affiliates, through SMS, email, Whatsapp message, RCS, call and push notifications. You may withdraw Your consent to receive such communications by sending an email to [EMAIL_ADDRESS]. By registering, you agree to our Terms & Conditions and Privacy Policy. You consent to receive automated service updates, support, and promotional messages from Winnsta at this number.
              </ListItem>

              <ListItem>
                Internet connectivity issues at Your end, disruptions due to Your local internet environment, errors in the setup of software or hardware of Your device, or other factors not directly attributable to Us, are beyond Our control, and accordingly, You agree that We will not incur any liability for any halts, breaks, or interruptions in Your usage of Our Services on account of such issues.
              </ListItem>

              <ListItem>
                You understand and acknowledge that once a Game/Tournament has commenced, not being able to play due to slow internet connections, faulty hardware, internet connection failure, low computer configuration or for some other reason are not attributable to the Company. You are solely and entirely responsible for such impairments.
              </ListItem>

              <ListItem>
                You agree not to to post any offensive, obnoxious, indecent or unsolicited content on the Platform including but not limited to any advertisement, promotional material, Your personal information or such other details. In the event of such posting, You shall keep the Company/Platform indemnified from and against all direct and indirect damage/loss resulting therefrom.
              </ListItem>
            </UnorderedList>
          </Box>

          {/* USER REGISTRATION per image */}
          <Box w="100%">
            <Text
              fontSize={{ base: "22px", md: "28px" }}
              fontWeight="bold"
              color="white"
              mb={6}
              textTransform="uppercase"
              letterSpacing="1px"
            >
              USER REGISTRATION
            </Text>

            <UnorderedList
              color="#EEDCFF"
              spacing={2}
              fontSize={{ base: "14px", md: "17px" }}
              pl={6}
            >
              <ListItem>
                When You register with Us, You are required to choose a username which shall be your identity (“User ID”) on the Platform. Your chosen username is confirmed subject to it being in compliance with these Terms and novelty.
              </ListItem>

              <ListItem>
                You may only have one account on Our Platform (“Account”), for which You will need to register using Your own, correct name with valid credentials and declaration of age, as sought at the time of registration. If We detect multiple accounts belonging to a single User, We may take penal action and/ or suspension of the linked accounts.
              </ListItem>

              <ListItem>
                User IDs must not be indecent, objectionable, offensive, or unlawful. User IDs that are found to violate the intellectual property of any entity, reveal personal information, or be suggestive of an advertising or promotional activity, may be rejected.
              </ListItem>

              <ListItem>
                Your User ID will remain active on the Platform unless We terminate or suspend Your access to the Platform for a violation of the Platform Policies in accordance with these Terms, or Your User Account becomes inactive in accordance with the Termination and Suspension clause provided herein.
              </ListItem>

              <ListItem>
                You may not share Your Account with any other User or person nor use the service by means of another Users Account. Should You attempt to open more than one Account, under Your own name or under any other name, or should You attempt to use the Service by means of any other Users Account, We will be entitled to close all Your Accounts and bar You from using the Services.
              </ListItem>

              <ListItem>
                You agree to abide by the rules and regulations of each of the Games as published and periodically amended on the Platform at the sole discretion of the Company. The rules that govern the Games offered on the Platform form part of the Terms and they will be available under the Game Rules or similar section on the Platform. However, if any rules are not explicitly mentioned on the Platform, the User is encouraged to seek clarification by using the customer support services offered. The interpretation/decision of the Company will be final, and You agree to abide by them by accepting these Terms.
              </ListItem>

              <ListItem>
                Sharing or distribution of the password with any other User/ person/ group or any third party is strictly prohibited. The Company is not responsible if Your Account is accessed or opened by others using Your password. You are held legally responsible and liable for all of Your activities on the Platform made from your Account, whether or not made by You.
              </ListItem>
            </UnorderedList>
          </Box>
          {/* COSMETIC PURCHASES per image */}
          <Box w="100%">
            <Text
              fontSize={{ base: "22px", md: "28px" }}
              fontWeight="bold"
              color="white"
              mb={6}
              textTransform="uppercase"
              letterSpacing="1px"
            >
              COSMETIC PURCHASES
            </Text>

            <UnorderedList
              color="#EEDCFF"
              spacing={2}
              fontSize={{ base: "14px", md: "17px" }}
              pl={6}
            >
              <ListItem>
                Users may opt to purchase cosmetic additions to the Games through in-app purchases on the User's relevant app Store. All payments for the cosmetic purchases are final and non-refundable, except as required by applicable law, governed in light of these Terms as specified at the time of purchase.
              </ListItem>

              <ListItem>
                The enhanced features that are provided on the Platform, include:
              </ListItem>

              <ListItem>
                The cosmetic purchases detailed hereinabove, in no manner alters the recreational and entertainment-only nature of the Services. Furthermore, it is explicitly clarified that such purchases, in any form or manner whatsoever, result in online money gaming under the provisions of the Promotion and Regulation of Online Gaming Act, 2025 or any other applicable state law in India.
              </ListItem>

              <ListItem>
                Users are responsible for any applicable taxes, duties, or levies associated with the cosmetic purchases.
              </ListItem>

              <ListItem>
                The Company does not process, store, or have access to Users’ payment card details.
              </ListItem>

              <ListItem>
                Any data obtained from the User in furtherance of such purchases shall be governed by these Terms and the Privacy Policy wherever applicable. However, any data given by the User to third parties shall be governed by the privacy policy of such third party and the Platform shall not be responsible for such information/data.
              </ListItem>

              <ListItem>
                Winnsta reserves the right, at its sole discretion, to modify the fees and benefits of the Membership at any time and Your continued use after such modifications shall constitute acceptance of the revised terms.
              </ListItem>
            </UnorderedList>
          </Box>
          {/* RESTRICTION ON USE OF SERVICES per image */}
          <Box w="100%">
            <Text
              fontSize={{ base: "22px", md: "28px" }}
              fontWeight="bold"
              color="white"
              mb={6}
              textTransform="uppercase"
              letterSpacing="1px"
            >
              RESTRICTION ON USE OF SERVICES
            </Text>

            <UnorderedList
              color="#EEDCFF"
              spacing={2}
              fontSize={{ base: "14px", md: "17px" }}
              pl={6}
            >
              <ListItem>
                Winnsta reserves the right, but is under no obligation, to monitor, review, pre-screen, edit, remove, or disable access to any User Content at its sole discretion.
              </ListItem>

              <ListItem>
                You shall not upload, distribute, transmit, publish, share, display, or post any content through Our Services including any communication feature provided by Us which belongs to another User and to which You do not have any right, is defamatory, obscene, pornographic, paedophilic, invasive of another's privacy including bodily privacy, insulting or harassing on the basis of gender, libellous, racially or ethnically objectionable, relating or encouraging money laundering or gambling, or otherwise inconsistent with or contrary to the laws in force, is harmful to a minor under the age of 18 (eighteen), deceives or misleads the addressee about the origin of the message, knowingly communicates any information which is false or misleading, impersonates another User or person, threatens the unity, integrity, defence, security or sovereignty of India, contains any software virus or malicious code designed to interrupt or damage computer systems, is patently false and intended to mislead or harass any User or entity, is otherwise objectionable or undesirable, is aimed at soliciting donations or help, disparages Winnsta or its affiliates, promotes competing services or products, or violates any Applicable Laws.
              </ListItem>

              <ListItem>
                You shall not use the Services for commercial purposes, including but not limited to use in a cyber cafe as a computer gaming centre, network play over the Internet, or through gaming networks, or connection to an unauthorized server that copies the gaming experience offered by Us.
              </ListItem>

              <ListItem>
                You shall not purchase, sell, trade, rent, lease, license, grant a security interest in, or transfer Your Account, content, rewards, prizes, standings, rankings, ratings, or any other attributes appearing in, originating from, or associated with the Services.
              </ListItem>

              <ListItem>
                You shall not send spam emails to any other User on the Platform, or any other form of unsolicited communication for any other purpose.
              </ListItem>

              <ListItem>
                Your ranking in the Tournaments organised by the Company may be disclosed to the relevant authorities in order to ensure compliance with Applicable Laws and lawful requests from the Government, regulatory authorities, or an order of any Court of competent jurisdiction.
              </ListItem>

              <ListItem>
                The Users admit that they may be exposed to content posted by other Users which they may find offensive, obnoxious or indecent and that the Platform may not be able to prevent such content being posted. You agree that You shall not hold the Company liable or responsible for such content in any manner. Such content should be brought to the notice of the Company who shall act upon the information as it deems acceptable. The decision taken by the management of the Company or the Platform in this regard shall be final and binding on the User and the User specifically agrees the Company will not incur any liability under any circumstance whatsoever regarding the same.
              </ListItem>

            </UnorderedList>
          </Box>

          {/* PROHIBITED CONDUCT */}
          <Box w="100%">
            <Text
              fontSize={{ base: "22px", md: "28px" }}
              fontWeight="bold"
              color="white"
              mb={6}
              textTransform="uppercase"
              letterSpacing="1px"
            >
              PROHIBITED CONDUCT
            </Text>

            <UnorderedList
              color="#EEDCFF"
              spacing={2}
              pl={6}
              fontSize={{ base: "14px", md: "17px" }}
            >
              <ListItem>
                Users are strictly prohibited from engaging in any activity that undermines the integrity, security, fairness, or lawful operation of the Platform.
              </ListItem>

              <ListItem>
                Without limitation and in addition to any other unlawful conduct highlighted in these Terms or other Platform Policies, the following actions constitute Prohibited Conduct and shall be deemed a material breach of these Terms:
              </ListItem>

              <ListItem>
                Engaging in, facilitating, or promoting any form of online money games, real-money gambling, wagering, or betting (including any attempt thereof), through, within, or in connection with the Platform or its Services (including its features), directly or indirectly.
              </ListItem>

              <ListItem>
                Selling, bartering, exchanging, or otherwise transferring the rewards, prizes, or User accounts for real-world currency, goods, or services, whether directly or through third-party intermediaries.
              </ListItem>
            </UnorderedList>
          </Box>

          {/* CUSTOMER VERIFICATION */}
          <Box w="100%">
            <Text
              fontSize={{ base: "22px", md: "28px" }}
              fontWeight="bold"
              color="white"
              mb={6}
              textTransform="uppercase"
              letterSpacing="1px"
            >
              CUSTOMER VERIFICATION
            </Text>

            <UnorderedList
              color="#EEDCFF"
              spacing={2}
              pl={6}
              fontSize={{ base: "14px", md: "17px" }}
            >
              <ListItem>
                Any User who is eligible to receive rewards, prizes on the basis of their ranking at the end of a Game or Tournament organized by the Company are required to complete a mandatory customer verification process (“Customer Verification”) prior to receiving such reward or prizes.
              </ListItem>

              <ListItem>
                As part of our Customer Verification protocol, Users are required to submit documents, which may include but not be limited to proof of identity, proof of address, tax identification, and a selfie image through our automated system.
              </ListItem>

              <ListItem>
                During the verification process, Users shall provide their Permanent Account Number (PAN) or any additional valid government issued document as valid proof as may be required by Winnsta.
              </ListItem>

              <ListItem>
                At the time of uploading the Customer Verification document on the Platform, You must ensure the following:
              </ListItem>

              <ListItem>
                Documents are original, accurate and authentic.
              </ListItem>

              <ListItem>
                The document is clear and legible, and shared in a jpg, jpeg, or pdf format.
              </ListItem>

              <ListItem>
                Documents are not password protected.
              </ListItem>

              <ListItem>
                We reserve the right to validate and/or reject the Customer Verification documents at our sole discretion. You will be notified of the status of Customer Verification on Your registered mobile number/email address.
              </ListItem>
            </UnorderedList>
          </Box>
          {/* TAXES */}
          <Box w="100%">
            <Text
              fontSize={{ base: "24px", md: "28px" }}
              fontWeight="bold"
              color="white"
              mb={4}
              textTransform="uppercase"
            >
              TAXES
            </Text>

            <UnorderedList
              color="#EEDCFF"
              spacing={2}
              pl={6}
              fontSize={{ base: "14px", md: "17px" }}
              lineHeight="1.6"
              textAlign="justify"
            >
              <ListItem>
                Any User who is eligible to receive rewards or prizes based on their
                ranking at the end of a Game or Tournament organized by the Company
                must complete a mandatory customer verification process (“Customer
                Verification”) prior to receiving such rewards or prizes.
              </ListItem>

              <ListItem>
                As part of our Customer Verification protocol, Users are required to
                submit documents, which may include but are not limited to proof of
                identity, proof of address, tax identification, and a selfie image
                through our automated system.
              </ListItem>

              <ListItem>
                During the verification process, Users shall provide their Permanent
                Account Number (PAN) or any additional valid government-issued
                document as valid proof as may be required by Winnsta.
              </ListItem>

              <ListItem>
                At the time of uploading the Customer Verification document on the
                Platform, You must ensure the following:
              </ListItem>

              <ListItem>
                Documents are original, accurate and authentic.
              </ListItem>

              <ListItem>
                The document is clear and legible, and shared in a jpg, jpeg, or pdf format.
              </ListItem>

              <ListItem>
                Documents are not password protected.
              </ListItem>

              <ListItem>
                We reserve the right to validate and/or reject the Customer Verification
                documents at our sole discretion. You will be notified of the status of
                Customer Verification on Your registered mobile number or email address.
              </ListItem>
            </UnorderedList>
          </Box>

          {/* SUSPENSION AND TERMINATION per image */}
          <Box w="100%">
            <Text
              fontSize={{ base: "22px", md: "28px" }}
              fontWeight="bold"
              color="white"
              mb={6}
              textTransform="uppercase"
              letterSpacing="1px"
            >
              SUSPENSION AND TERMINATION
            </Text>

            <UnorderedList
              color="#EEDCFF"
              spacing={2}
              pl={6}
              fontSize={{ base: "14px", md: "17px" }}
              lineHeight="1.6"
              textAlign="justify"
            >
              <ListItem>
                We reserve the right to suspend or terminate Your Account if We find that
                You are violating any of Our Platform Policies, or breaching / attempting
                to breach the security of Our Services in any manner.
              </ListItem>

              <ListItem>
                In the event Your Account is terminated by Us in accordance with the
                above-mentioned clause, You will not be permitted to use our Services
                thereafter using the mobile number, proof of address, proof of identity,
                or other details linked to the terminated Account.
              </ListItem>

              <ListItem>
                If We find that a User is breaching or attempting to breach our security or
                privacy protocols, We may, following an internal investigation, undertake
                remedial actions depending on the severity of the breach, including the
                following:
              </ListItem>

              <ListItem>
                Stop access and usage of our Services indefinitely by such User.
              </ListItem>

              <ListItem>
                Permanently terminate such User’s Account.
              </ListItem>

              <ListItem>
                Demand compensation for damages caused to our Services and prosecute the
                User for any violation of the law or Platform Policies if required.
              </ListItem>

              <ListItem>
                Prohibit the User from registering with Us in the future and cancel all
                previous transactions.
              </ListItem>

              <ListItem>
                We may investigate and monitor Your Account and gameplay for up to 180 days
                from the notification of a breach. This investigation may cover all Games
                played since the User registered on the Platform.
              </ListItem>

              <ListItem>
                We reserve the right to suspend or block an Account at our sole discretion
                if instructed by or made aware of cyber fraud or any fraudulent activity by
                governmental, police, or law enforcement authorities.
              </ListItem>

              <ListItem>
                You may discontinue using Our Services at any time by sending us an email
                indicating such intention (“Discontinuation Request”).
              </ListItem>

              <ListItem>
                Where access to Your Account is restricted due to unsuccessful Account
                validation, we may take up to seven (7) working days to reinstate full
                access after successful validation. If we are unable to reach You after
                multiple attempts, we reserve the right to terminate the Account. We shall
                not be liable for any loss or damage resulting from such termination or
                restriction.
              </ListItem>
            </UnorderedList>
          </Box>

          {/* REPRESENTATION AND WARRANTIES per image */}
          <Box w="100%">
            <Text
              fontSize={{ base: "22px", md: "28px" }}
              fontWeight="bold"
              color="white"
              mb={6}
              textTransform="uppercase"
              letterSpacing="1px"
            >
              REPRESENTATION AND WARRANTIES
            </Text>

            <UnorderedList
              color="#EEDCFF"
              spacing={2}
              pl={6}
              fontSize={{ base: "14px", md: "17px" }}
              lineHeight="1.6"
              textAlign="justify"
            >
              <ListItem>
                You are eligible and competent to access and use the Services offered by Winnsta.
              </ListItem>

              <ListItem>
                Any information You provide to Us at any time during the access and use of the Services, whether at the stage of registration or at any time thereafter, is correct, complete, up-to-date, and accurate. We shall not be liable against any claim relating to the accuracy, completeness, or correctness of any information You provide Us.
              </ListItem>

              <ListItem>
                We may, at any time and at Our sole discretion, require You to verify the correctness, completeness, and accuracy of such information and may require You to produce additional documentary proof. Where You fail to provide valid documentary proof, We reserve the right to limit Your access to and use of Our Services.
              </ListItem>

              <ListItem>
                You will protect the information You provide Us, including Your password used to avail of Our Services. We will never require You to enter or disclose Your Account password except at the time of logging into the Platform. You must never share Your Account login information with anyone, including other Users or representatives of Winnsta. You understand and agree that We will not incur any liability for information provided by You to any person which may result in Your Account being exposed or misused.
              </ListItem>

              <ListItem>
                You shall use Your Account solely for the purpose of playing the Games and Tournaments offered through Our Services, and the Services shall not be used to launder funds or commit any unlawful or prohibited activity.
              </ListItem>

              <ListItem>
                You have the experience and requisite skills required to play Games on the Platform and are not aware of any physical or mental condition that would impair Your capability to fully participate in such activity.
              </ListItem>

              <ListItem>
                You understand and accept that participation in a Game does not create any obligation on Us to provide rewards or prizes. Winning a reward or prize depends entirely on the outcome of the Game or Tournament and Your ranking based on Your skill relative to other Users, and is subject to the Platform Policies.
              </ListItem>

              <ListItem>
                Winnsta is not responsible for Your inability to access or play any Game or Tournament for which You may be eligible. This includes cases where You cannot log in to Your Account, the Account is pending validation, or You are suspected of violating any Platform Policy.
              </ListItem>

              <ListItem>
                You will not attempt to use the Platform in any manner, directly or indirectly, to aid, abet, facilitate, engage in, or induce other Users to participate in any external exchange, transfer, or misuse of any Platform Service.
              </ListItem>
            </UnorderedList>
          </Box>
          {/* DISCLAIMER per image */}
          <Box w="100%">
            <Text fontSize={{ base: "22px", md: "28px" }} fontWeight="bold" color="white" mb={6} textTransform="uppercase" letterSpacing="1px">
              DISCLAIMER
            </Text>
            <UnorderedList color="#EEDCFF"
              spacing={2}
              pl={6}
              fontSize={{ base: "14px", md: "17px" }}
              lineHeight="1.6"
              textAlign="justify">
              <ListItem >
                The information, software, products, services and content available through the platform are provided to you “as is” and without warranty. Winnsta and its subsidiaries, affiliates, officers, employees, agents, partners and licensors hereby disclaim all warranties with regard to such information, software, products, services and content, including, without limitation, all implied warranties and conditions of merchantability, fitness for a particular purpose, title and noninfringement. Winnsta and its subsidiaries, affiliates, officers, employees, agents, partners and licensors make no warranty that: (a) the service will meet your requirements; (b) the results that may be obtained from the use of the service will be accurate or reliable; (c) the quality of any services, information or other material obtained by you through the service will meet your expectations; and (d) any errors in the services will be corrected.
              </ListItem>
            </UnorderedList>
          </Box>

          {/* LIMITATION OF LIABILITY AND INDEMNITY per image */}
          <Box w="100%">
            <Text fontSize={{ base: "22px", md: "28px" }} fontWeight="bold" color="white" mb={6} textTransform="uppercase" letterSpacing="1px">
              LIMITATION OF LIABILITY AND INDEMNITY
            </Text>
            <UnorderedList
              color="#EEDCFF"
              spacing={2}
              pl={6}
              fontSize={{ base: "14px", md: "17px" }}
              lineHeight="1.6"
              textAlign="justify"
            >
              <ListItem>
                You agree to indemnify and hold harmless Winnsta against any claims,
                actions, suits, damages, penalties, or awards brought against Us by any
                entity or individual in connection with or in respect of Your use of the
                Services.
              </ListItem>

              <ListItem>
                The Platform is offered by Winnsta on an as-is basis and Winnsta makes no
                implied warranties with respect to the Service. All implied warranties of
                merchantability and fitness for a particular purpose or use are disclaimed.
                No one is authorized to make any warranty on Our behalf, and Users may not
                rely on any other statement of warranty. However, where we receive adequate
                notice of an error in the Services, We shall take prompt steps to rectify
                the same.
              </ListItem>

              <ListItem>
                Winnsta expressly disclaims all responsibility and liability for any harm,
                damages, or loss resulting from Your participation in, or cancellation of,
                any Game, any activity and any User-generated content, including any
                violation of intellectual property rights with respect to such
                User-generated content.
              </ListItem>

              <ListItem>
                A failure by Us to insist upon strict performance of any of the provisions
                herein or to exercise any option, right or remedy contained herein shall
                not be construed as waiver or relinquishment of such provisions, option,
                right or remedy. No waiver of any provision hereof shall be deemed to have
                been made unless expressed in writing and signed.
              </ListItem>

              <ListItem>
                The latest versions of the Platform Policies, as published on the Platform,
                contain the entire agreement between You and Us regarding the access to and
                use of the Services and supersede all prior agreements, including prior
                versions of the Platform Policies.
              </ListItem>

              <ListItem>
                You are accountable to obey any Applicable Law while taking part in any
                Games or Tournament organized through the Platform. You undertake and agree
                to assure us against any claims, expenses or liabilities suffered by or
                claimed against us by any person or entity arising out of your
                non-compliance with any Applicable Laws and/or resulting from any activity
                through your Account.
              </ListItem>
            </UnorderedList>
          </Box>

          {/* COMPLAINTS AND DISPUTES per image */}
          <Box w="100%">
            <Text fontSize={{ base: "22px", md: "28px" }} fontWeight="bold" color="white" mb={6} textTransform="uppercase" letterSpacing="1px">
              COMPLAINTS AND DISPUTES
            </Text>
            <UnorderedList
              color="#EEDCFF"
              spacing={2}
              pl={6}
              fontSize={{ base: "14px", md: "17px" }}
              lineHeight="1.6"
              textAlign="justify"
            >
              <ListItem>
                GRIEVANCE DEPARMENT
              </ListItem>

              <ListItem>
                If You have any complaint or grievance relating to any aspect of the
                Services, You may approach Our customer care and grievance redressal team
                for the resolution of such issues by writing to support@winnsta.com.
              </ListItem>

              <ListItem>
                You agree that all complaints and disputes at Winnsta are to be kept
                confidential. We will endeavour to resolve all grievances within a
                reasonable period, as mandated under Applicable Laws. Any decision taken by
                Us relating to any complaint will be binding on the User.
              </ListItem>

              <ListItem>
                The following are the details of Our Grievance Department:
              </ListItem>

              <ListItem>
                Email address: support@winnsta.com
              </ListItem>

              <ListItem>
                The aforementioned Grievance Department has been appointed in light of the
                Applicable Laws, including but not limited to the Promotion and Regulation
                of Online Gaming Act (2025), Information Technology Act, 2000 and the
                Information Technology (Intermediary Guidelines and Digital Media Ethics
                Code) Rules, 2021 enacted thereunder.
              </ListItem>

              <ListItem>
                You agree that the Grievance Department can be replaced by us at Our sole
                discretion through the publication of such replacement on Our Platform.
              </ListItem>

              <ListItem>
                If a User is dissatisfied with the resolution provided by the Grievance
                Department and the Company or receives no response within a specified time
                period, they may appeal to the Grievance Appellate Committee established
                under the Information Technology (Intermediary Guidelines and Digital Media
                Ethics Code) Rules, 2021 within thirty (30) days as prescribed.
              </ListItem>

              <ListItem>
                NODAL CONTACT PERSON -
              </ListItem>

              <ListItem>
                In accordance with the IT Act and the rules made thereunder, we have
                appointed a Nodal Contact Person who shall be available for 24x7
                coordination with law enforcement agencies and officers to ensure
                compliance with their orders or requisitions made in accordance with the
                provisions of law or rules made thereunder.
              </ListItem>

              <ListItem>
                Following are the details of the Nodal Contact Person:
              </ListItem>

              {/* <ListItem>
    Name: [*]
  </ListItem> */}

              <ListItem>
                Email: support@winnsta.com
              </ListItem>
            </UnorderedList>
          </Box>

          {/* GOVERNING LAW, DISPUTE RESOLUTION, AND JURISDICTION */}
          <Box w="100%">
            <Text fontSize={{ base: "24px", md: "28px" }} fontWeight="bold" color="white" mb={4} textTransform="uppercase">
              GOVERNING LAW, DISPUTE RESOLUTION, AND JURISDICTION
            </Text>
            <UnorderedList color="#EEDCFF" spacing={2} pl={6} fontSize={{ base: "14px", md: "17px" }} >
              <ListItem> The Platform Policies are governed by and shall be interpreted in accordance with the laws of India.</ListItem>
              <ListItem> Subject to the arbitration clause mentioned hereinbelow, any dispute, controversy, or claim against the Us or arising out of these Platform Policies shall be subject to the exclusive jurisdiction of the civil courts at Goa, India.</ListItem>
              <ListItem> In the event of any legal dispute arising in relation to any aspect of the Platform Policies, or the use of our Services by You, You must provide written notification to Us of the dispute and relevant details. We shall attempt to resolve the dispute through discussions with You, and where such resolution fails to be concluded within thirty (30) days, the dispute may be referred to arbitration. The arbitration shall be conducted before a tribunal of three (3) arbitrators wherein both Winnsta and You shall be entitled to appoint one (1) arbitrator each and the two (2) arbitrators shall jointly appoint the third arbitrator. The place of arbitration shall be Panaji, Goa, and the arbitration proceedings shall be conducted, in English, in accordance with the provisions of the Arbitration and Conciliation Act, 1996. The award arising from such arbitration proceedings will be final and binding on the parties, and each party will bear its own costs of arbitration and equally share the fees of the arbitrator unless the arbitral tribunal decides otherwise.</ListItem>
              <ListItem> Notwithstanding anything in the Arbitration clause hereinabove, Winnsta shall be entitled to seek and obtain from a court of competent jurisdiction, an interim or permanent equitable or injunctive relief, or any other relief available under Applicable Laws, to safeguard its interest, at any time during the pendency of a dispute with You or any other person, and such pursuit of relief shall not constitute a waiver of the arbitration process mandated herein.</ListItem>
            </UnorderedList>
          </Box>

          {/* General Provisions */}
          <Box w="100%" mb={12}>
            <Text fontSize={{ base: "22px", md: "28px" }} fontWeight="bold" color="white" mb={6} textTransform="uppercase" letterSpacing="1px">
              General Provisions
            </Text>
            <UnorderedList
              color="#EEDCFF"
              spacing={2}
              pl={6}
              fontSize={{ base: "14px", md: "17px" }}
              lineHeight="1.6"
              textAlign="justify"
            >
              <ListItem>
                <strong>Entire Agreement:</strong> The Platform Policies constitute an
                entire, valid and binding agreement between you and the Company and govern
                your access and use of the Platform at all times.
              </ListItem>

              <ListItem>
                <strong>Advertisement:</strong> The Company shall have the right to place
                advertisements and publicity materials of its choice, including that
                pertaining to parties other than itself for commercial use through
                electronic means on the Platform.
              </ListItem>

              <ListItem>
                <strong>Waiver:</strong> The failure of the Platform to exercise any right
                provided for herein shall not be deemed a waiver of any further right
                hereunder and under any of the Platform Policies and applicable laws.
              </ListItem>

              <ListItem>
                <strong>Assignment:</strong> You may not assign or sub-license, without the
                prior written consent of the Company, the rights, duties or obligations
                under the Terms, in whole or in part, to any person or entity. The Company
                may assign or sub-license in whole or in part any of its rights, duties or
                obligations under the Terms to any of its affiliates.
              </ListItem>
            </UnorderedList>
          </Box>

        </Flex>
      </Flex>
    </Box>
  );
};

export default Terms;
